import Dinero from 'dinero.js';
import type { Currency } from 'dinero.js';

export function formatCurrency(amount: number, currency: Currency = 'USD', format: string = '$0,0.00') {
    return Dinero({ amount, currency }).toFormat(format);
}
